// theme.js
import { createTheme } from '@mui/material/styles';

// Light mode palette (unchanged)
const modernPalette = {
  primary: {
    main: '#2979ff',
    light: '#75a7ff',
    dark: '#004ecb',
    contrastText: '#fff',
  },
  secondary: {
    main: '#f44336',
    light: '#ff7961',
    dark: '#ba000d',
    contrastText: '#fff',
  },
  background: {
    default: '#f8f9fa',
    paper: '#fff',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.6)',
  },
};

// Dark mode palette — adjusted to match #131b2b
const darkModernPalette = {
  primary: {
    main: '#6aa9ff', // Brightened blue for visibility on dark bg
    light: '#9ccfff',
    dark: '#2979ff',
    contrastText: '#fff',
  },
  secondary: {
    main: '#ff867c', // Soft warm accent for contrast
    light: '#ffb3a7',
    dark: '#c75b52',
    contrastText: '#fff',
  },
  background: {
    default: '#131b2b', // Main dark background
    paper: '#1a2335', // Slightly lighter for cards/appbar
  },
  text: {
    primary: '#ffffff', // Clean white text
    secondary: 'rgba(255, 255, 255, 0.7)', // Softer text tone
  },
};

export const lightTheme = createTheme({
  palette: modernPalette,
  typography: {
    fontFamily: "'Nunito', sans-serif",
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: modernPalette.background.paper,
          color: modernPalette.text.primary,
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    ...darkModernPalette,
  },
  typography: {
    fontFamily: "'Nunito', sans-serif",
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: darkModernPalette.background.paper,
          color: darkModernPalette.text.primary,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: darkModernPalette.background.default,
          color: darkModernPalette.text.primary,
        },
      },
    },
    MuiAlert: {
        styleOverrides: {
            standardInfo: {
            backgroundColor: darkModernPalette.background.paper,
            color: darkModernPalette.text.primary,
            border: `1px solid ${darkModernPalette.primary.main}`,
            '& .MuiAlert-icon': {
                color: darkModernPalette.primary.main,
            },
            },
            standardSuccess: {
            backgroundColor: darkModernPalette.background.paper,
            color: darkModernPalette.text.primary,
            border: `1px solid ${darkModernPalette.primary.light}`,
            '& .MuiAlert-icon': {
                color: darkModernPalette.primary.light,
            },
            },
            standardError: {
            backgroundColor: darkModernPalette.background.paper,
            color: darkModernPalette.text.primary,
            border: `1px solid ${darkModernPalette.secondary.main}`,
            '& .MuiAlert-icon': {
                color: darkModernPalette.secondary.main,
            },
            },
            standardWarning: {
            backgroundColor: darkModernPalette.background.paper,
            color: darkModernPalette.text.primary,
            border: `1px solid #fbc02d`, // Optional warm yellow
            '& .MuiAlert-icon': {
                color: '#fbc02d',
            },
            },
        },
    },
  },
});
